import { Component, OnInit, Input, ElementRef, Renderer2 } from '@angular/core';
import { FormBuilder, Validators, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ProDefiniciones } from '@shared/interfaces/request/proDefiniciones';
import { ConceptosService } from '@p-p-portafolio/services/conceptos.service';
import { ProDefinicionesService } from '@p-p-portafolio/services/pro-definiciones.service';
import { TasasService } from '@p-p-portafolio/services/tasas.service';
import { UserService } from '@pages/user/services/user.service';
import { InjectableService } from '@shared/utils/injectable.service';
import { SwalService } from '@shared/utils/swal.service';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { DefinicionesFormComponent } from '../definiciones-form.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SessionService } from '@shared/helpers/sesion.service';

@Component({
  selector: 'app-def-intereses',
  templateUrl: './def-intereses.component.html',
  styleUrls: ['./def-intereses.component.css']
})
export class DefInteresesComponent implements OnInit {
  @Input() modelRecived: ProDefiniciones;
  private _user: string = this._userServices.userCurrent;
  public promocion: string = localStorage.getItem('prom');
  public breakpoint: number;
  public tasas: any[];
  public conceptos: any[];
  public calculate: any[];
  public aplicateTo: any[];
  public calculate2: any[];
  public formPrincipal: boolean = true;
  public selectTasa: boolean;
  public selectCocepto: boolean;
  public selectCocepto2: boolean;
  public loading: boolean;
  public solicitudesValores: any[] = [];
  constructor(
    private _fb: FormBuilder,
    private _dialogRef: MatDialogRef<DefinicionesFormComponent>,
    private _swalService: SwalService,
    private _proDefServices: ProDefinicionesService,
    private _userServices: UserService,
    private _injectServices: InjectableService,
    private _tasasServices: TasasService,
    private _conceptosServices: ConceptosService,
    private renderer: Renderer2,
    private _snackBar: MatSnackBar,
    private el: ElementRef,
    private _sessionService: SessionService
  ) {}

  ngOnInit(): void {
    this.readCalculate();
    this.readAplicateTo();
    this.readCalculate2();
    this.readSolicitudesValores();
    this.setForm();
    this.readConceptos();
    this.injectConcepto();
    this.readTasas();
    this.injectTasa();
    this.onBreakPonit();
  }

  form = this._fb.group({
    promocion: [this.promocion],
    numVar: [
      '',
      {
        validators: [Validators.required, this.variableValidation()],
        asyncValidators: [this.singleDefinicion()],
        updateOn: 'blur'
      }
    ],
    descripcion: ['', Validators.required],
    claveTasa: [''],
    valorFijo: ['0.0'],
    amortInf: [0],
    amortSup: [0],
    formula: [''],
    porcentaje: ['0.0', Validators.required],
    concepto: ['', Validators.required],
    conceptoAdicional: [0],
    user: this._user,
    // Valores que van en formula
    calculate: [1],
    calculate2: [1],
    aplicateTo: [1]
  });

  readCalculate() {
    let iTipo: number = 20;
    this._proDefServices.proDefGasValores(iTipo).subscribe((res) => {
      this.calculate = res.data;
    });
  }

  readAplicateTo() {
    let iTipo: number = 21;
    this._proDefServices.proDefGasValores(iTipo).subscribe((res) => {
      this.aplicateTo = res.data;
    });
  }

  readCalculate2() {
    let iTipo: number = 22;
    this._proDefServices.proDefGasValores(iTipo).subscribe((res) => {
      this.calculate2 = res.data;
    });
  }

  readSolicitudesValores() {
    this.loading = true;
    this._proDefServices.getSolicitudesValores(this._sessionService.getUserSession()).subscribe({
      next: (res) => {
        if (res.success) {
          this.solicitudesValores = res.data;
          console.log('Valores cargados:', this.solicitudesValores);
          // Si hay un modelo recibido, asignamos el valorFijo al calculate
          if (this.modelRecived) {
            this.form.patchValue({
              calculate: this.modelRecived.valorFijo
            });
          }
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error al cargar valores de solicitudes:', err);
        this._swalService.error('Error al cargar valores de solicitudes');
        this.loading = false;
      }
    });
  }

  readConceptos() {
    this._conceptosServices.getAll().subscribe((res) => {
      this.conceptos = res;
    });
  }

  injectConcepto() {
    this._injectServices.disparadorConcepto.subscribe((res) => {
      if (this.selectCocepto2) this.form.patchValue({ conceptoAdicional: res.model.data });
      else this.form.patchValue({ concepto: res.model.data });
      if (res.model.success) this.changeBoolean('form');
    });
  }

  readTasas() {
    this._tasasServices.read().subscribe((res) => {
      this.tasas = res.data;
    });
  }

  injectTasa() {
    this._injectServices.disparadorTasas.subscribe((res) => {
      this.form.patchValue({ claveTasa: res.model.data });
      if (res.model.success) this.changeBoolean('form');
    });
  }

  changeBoolean(change: string) {
    switch (change) {
      case 'form':
        this.selectCocepto = false;
        this.selectCocepto2 = false;
        this.selectTasa = false;
        this.formPrincipal = true;
        break;
      case 'conceptos':
        this.formPrincipal = false;
        this.selectCocepto = true;
        break;
      case 'tasas':
        this.formPrincipal = false;
        this.selectTasa = true;
        break;
      case 'conceptos2':
        this.formPrincipal = false;
        this.selectCocepto = true;
        this.selectCocepto2 = true;
        break;
    }
  }

  create(model: ProDefiniciones) {
    if (this.form.valid) {
      this.loading = true;
      model = { ...model, formula: this.setFormula() };
      this._proDefServices.create(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Agregado');
        } else this._swalService.error('No Agregado');
      });
    }
  }

  update(model: ProDefiniciones) {
    if (this.form.valid) {
      this.loading = true;
      model = { ...model, formula: this.setFormula() };
      this._proDefServices.update(model).subscribe((res) => {
        this.loading = false;
        if (res.exito === 1) {
          this._dialogRef.close();
          this._swalService.success('Editado');
        } else this._swalService.error('No Editado');
      });
    }
  }

  formValue(value: string) {
    return this.form.get(value);
  }

  //#region Validations
  variableValidation(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const variable = control.value;
      if (variable == null || variable === '') return null;
      if (variable >= 701 && variable <= 800) {
        return null;
      }

      this._snackBar.open('El rango de variables para Intereses es de 701 a 800', 'cerrar', { duration: 5000 });
      const input = this.el.nativeElement.querySelector('#numVar');
      if (input) {
        this.renderer.addClass(input, 'is-invalid');
      }

      return { variableValidation: true };
    };
  }

  //#endregion

  singleDefinicion(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | any> => {
      if (this.modelRecived) return of(null);

      return this._proDefServices.readOne(this.promocion, control.value).pipe(
        tap(() => {
          const input = this.el.nativeElement.querySelector('#numVar');
          this.renderer.removeClass(input, 'is-invalid');
        }),
        map((res) => {
          const input = this.el.nativeElement.querySelector('#numVar');
          // 1 → la promoción no existe  ⇒  VÁLIDA
          if (res.exito === 1) {
            this.renderer.addClass(input, 'is-invalid'); // aura roja
            this._snackBar.open('Variable en uso, intente con otra.', 'cerrar', { duration: 5000 });
            return { singleDefinicion: true }; // ← objeto de error
          }
          // distinto de 1 → libre  ⇒  INVÁLIDA
          return null; // ← sin errores
        })
      );
    };
  }
  //#endregion

  setFormula(): string {
    let sep = '|';
    let calculate = this.form?.controls.calculate.value;
    let aplicateTo = this.form?.controls.aplicateTo.value;
    let calculate2 = this.form?.controls.calculate2.value;

    let lst = calculate + sep + aplicateTo + sep + calculate2 + sep;

    // this.form.patchValue({ formula: lst });

    return lst;
  }

  getFormula(formula: string): void {
    let formulaSep: string[] = formula.split('|');
    const setFormula = {
      // Valores que van en formulas
      calculate: Number(formulaSep[0]),
      aplicateTo: Number(formulaSep[1]),
      calculate2: Number(formulaSep[2])
    };
    this.form.patchValue(setFormula);
  }

  setForm(): void {
    console.log(' this.modelRecived', this.modelRecived);
    if (this.modelRecived !== null) {
      let model: ProDefiniciones = this.modelRecived;
      this.getFormula(model.formula);
      const setModel = {
        promocion: model.promocion,
        numVar: model.numVar.toString(),
        descripcion: model.descripcion,
        claveTasa: model.claveTasa,
        valorFijo: model.valorFijo.toString(),
        amortInf: model.amortInf,
        amortSup: model.amortSup,
        formula: model.formula,
        porcentaje: model.porcentaje.toString(),
        concepto: model.concepto.toString(),
        conceptoAdicional: model.conceptoAdicional,
        user: this._sessionService.getUserSession()
      };
      this.form.patchValue(setModel);
    }
  }

  onBreakPonit() {
    this.breakpoint = window.innerWidth <= 400 ? 1 : 2;
  }

  onResize(event) {
    this.breakpoint = event.target.innerWidth <= 400 ? 1 : 2;
  }

  close() {
    this._dialogRef.close();
  }
}
